import type { ThemeGrid, ZIndexConfig } from '@landsbankinn/ui-kit';

export const zIndexConfig: ZIndexConfig = {
  tooltip: 2011,
  dropdown: 9994,
  snackbar: 9993,
  dab: 9992,
  dialog: 9991,
  fab: 2,
  actionSheet: 3,
  bottomNavigation: 1,
  fixedOrStickyBox: 1,
  numpad: 0,
};

export const THEME_GRID_IDP: ThemeGrid = {
  breakpoints: {
    xs: '0px',
    sm: '376px',
    md: '768px',
    lg: '1024px',
    xl: '1320px',
  },
  gutter: {
    xs: '2rem',
    sm: '2rem',
    md: '2rem',
    lg: '2rem',
    xl: '2rem',
  },
  padding: {
    xs: '3.6rem',
    sm: '3.6rem',
    md: '10rem',
    lg: '10rem',
    xl: '7rem',
  },
  container: {
    xs: '100%',
    sm: '100%',
    md: '100%',
    lg: '100%',
    xl: '1320px',
  },
  columns: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  unresponsive: false,
};
